__turbopack_context__.v({
  "active": "List-module-scss-module__8KwJIa__active",
  "blink": "List-module-scss-module__8KwJIa__blink",
  "header": "List-module-scss-module__8KwJIa__header",
  "image": "List-module-scss-module__8KwJIa__image",
  "project": "List-module-scss-module__8KwJIa__project",
  "projectLink": "List-module-scss-module__8KwJIa__projectLink",
  "projectsList": "List-module-scss-module__8KwJIa__projectsList",
  "region": "List-module-scss-module__8KwJIa__region",
  "status": "List-module-scss-module__8KwJIa__status",
  "year": "List-module-scss-module__8KwJIa__year",
});
